module.exports = __webpack_public_path__ + "static/img/title.5cb280b.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/activity4/title.png
// module id = vTB2
// module chunks = 7